import React from 'react';
import { ShieldCheck, Sun, Heart, Smile, Brain, Zap, Moon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function BenefitsSection() {
  const benefits = [{
    icon: ShieldCheck,
    title: 'Dejar de improvisar y tener un plan claro'
  }, {
    icon: Sun,
    title: 'Entender qué necesita tu hijo sin adivinar'
  }, {
    icon: Zap,
    title: 'Manejar berrinches sin gritos ni culpa'
  }, {
    icon: Moon,
    title: 'Mejorar el sueño de tu hijo (y el tuyo)'
  }, {
    icon: Heart,
    title: 'Crear un vínculo más fuerte y consciente'
  }, {
    icon: Smile,
    title: 'Disfrutar la maternidad en vez de sobrevivirla'
  }];
  return <section className="bg-brand-cream py-24 px-6" data-id="element-28">
      <div className="max-w-6xl mx-auto" data-id="element-29">
        <div className="text-center mb-16" data-id="element-30">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-brand-black mb-4" data-id="element-31">
            En menos de 30 días vas a poder:
          </h2>
          <div className="w-24 h-1 bg-brand-sage mx-auto rounded-full" data-id="element-32"></div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-33">
          {benefits.map((benefit, index) => <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300 border border-brand-sage/5 group" data-id="element-34">
              <div className="w-14 h-14 bg-brand-cream rounded-xl flex items-center justify-center text-brand-sage mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-35">
                <benefit.icon className="w-7 h-7" data-id="element-36" />
              </div>
              <h3 className="text-xl font-bold text-brand-charcoal mb-2" data-id="element-37">
                {benefit.title}
              </h3>
            </div>)}
        </div>

        <div className="text-center" data-id="element-38">
          <CTAButton text="QUIERO EMPEZAR HOY" data-id="element-39" />
          <p className="text-sm text-brand-red font-bold mt-3" data-id="element-40">
            Todo por solo $19.990 — Oferta por tiempo limitado
          </p>
        </div>
      </div>
    </section>;
}